import {cloneLayer} from "cartovistaExtend/utils/CvUtils";
import "styles/SaveSelection.css";﻿

    var addSelectedDataBtnHTML = '<button id="SaveSelectionTool_addBtn" class="cv-fade cv-button k-button k-button-icon" data-role="button" role="button" aria-disabled="false" tabindex="-1" title="Créer une nouvelle couche à partir de la sélection">' +
                                    '<span class="k-sprite cv-icon cv-icon-add"></span>' +
                                '</button>';

    export default class SaveSelection {
      constructor() {
        this._map = window.cartovista.externalInterface.map;
        this._$addSelectedDataBtn = $(addSelectedDataBtnHTML);
        this._$addSelectedDataBtn.click(this._onAddDataToMapBtnClicked.bind(this));

        this._selectionDataViewController = window.cartovista.getUIController(this._map).findInstance("dataView-selectedFeatures");
        var _generateUiFn = this._selectionDataViewController._generateUI.bind(this._selectionDataViewController);
        this._selectionDataViewController._generateUI = function() {
            _generateUiFn();
            $(this._selectionDataViewController.rightAction).append(this._$addSelectedDataBtn);
        }.bind(this);
      }

    _onAddDataToMapBtnClicked(evt) {
        var selectedLayer = this._map.selectionLayer;
        selectedLayer.computeSelectionStack(function(linkingIds){
            var selectedFeaturesIds = linkingIds;
            if (selectedLayer && selectedFeaturesIds.length) {
                this._map.addLayerAt(cloneLayer(selectedLayer, selectedFeaturesIds), this._map._layerDepths[selectedLayer.id]);
            }
        }.bind(this));
    };

}
